import { IRowDimensions, IRows, IDisplayRow } from './types';

export const calulateDimensions = (rows: IRows): [number, IRowDimensions] => {
  let newTotalHeight = 0;
  const newRowDimensions: IRowDimensions = {};
  Object.keys(rows).forEach((index: string) => {
    const row = rows[index];

    if (row === null) {
      return;
    }

    newRowDimensions[index] = {
      top: newTotalHeight,
      bottom: newTotalHeight + row.rowHeight,
    };
    newTotalHeight = newTotalHeight + row.rowHeight;
  });

  return [newTotalHeight, newRowDimensions];
};

export const getDisplayRows = ({
  rows,
  rowDimensions,
  currentTop,
  winHeight,
  totalHeight,
  cntTop,
}: {
  rows: IRows;
  rowDimensions: IRowDimensions;
  currentTop: number;
  winHeight: number;
  totalHeight: number;
  cntTop: number;
}): { visibleRows: IDisplayRow[]; paddingTop: number; paddingBottom: number } => {
  const newVisibleRows: IDisplayRow[] = [];
  let paddingTop = 0;
  let contentHeight = 0;
  let isPaddingTopSet = false;

  const indexes = Object.keys(rowDimensions);

  const scrollTop = cntTop > 0 ? currentTop + cntTop : currentTop;

  // TODO - change padding logic to be based on scroll speed and direction
  const viewportPadding = winHeight;
  const viewPortTop = scrollTop - viewportPadding;
  const viewPortBottom = scrollTop + winHeight + viewportPadding;

  const canShowRow = (rowTop: number, rowBottom: number) => {
    return (
      (rowTop >= viewPortTop && rowTop <= viewPortBottom) || // If row top is inside virtual viewport
      (rowBottom >= viewPortTop && rowBottom <= viewPortBottom) || // If row bottom is inside virtual viewport
      (viewPortTop >= rowTop && viewPortBottom <= rowBottom) // If virtual viewport is inside row dimension
    );
  };

  // get first visibile row index
  const startIndex = indexes.findIndex((index: string) => {
    const row = rows[index];
    const rowDimen = rowDimensions[index];

    if (rowDimen === null || row === null) {
      return false;
    }

    return canShowRow(rowDimen.top, rowDimen.bottom);
  });

  let loop = true;
  let rowIndex = startIndex;
  // loop till we find last visible row or last index
  while (loop) {
    const index = indexes[rowIndex];
    const row = rows[index];
    const rowDimen = rowDimensions[index];

    if (rowDimen === undefined || rowDimen === null || row === undefined || row === null) {
      rowIndex = rowIndex + 1;
      if (indexes[rowIndex] === undefined) {
        loop = false;
      }
      continue;
    }

    if (canShowRow(rowDimen.top, rowDimen.bottom)) {
      if (isPaddingTopSet === false) {
        paddingTop = rowDimen.top;
        isPaddingTopSet = true;
      }
      newVisibleRows.push({
        ...row,
        index,
      });
      contentHeight = contentHeight + row.rowHeight;
    } else {
      loop = false;
      continue;
    }

    rowIndex = rowIndex + 1;
    if (indexes[rowIndex] === undefined) {
      loop = false;
    }
  }

  const paddingBottom = totalHeight - (paddingTop + contentHeight);

  return { visibleRows: newVisibleRows, paddingTop, paddingBottom };
};
